var _excluded = ["size", "color", "style", "className", "spin", "rotate"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FoxIconCheckCore = function FoxIconCheckCore(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    role: "img"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M883.498667 225.834667a42.666667 42.666667 0 0 1 0 60.330666l-469.333334 469.333334a42.666667 42.666667 0 0 1-60.330666 0l-213.333334-213.333334a42.666667 42.666667 0 1 1 60.330667-60.330666L384 665.002667 823.168 225.834667a42.666667 42.666667 0 0 1 60.330667 0z"
    })
  }));
};
var Memo = /*#__PURE__*/memo(FoxIconCheckCore);
/**
 * ![FoxIconCheck](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCI+PHBhdGggZD0iTTg4My40OTg2NjcgMjI1LjgzNDY2N2E0Mi42NjY2NjcgNDIuNjY2NjY3IDAgMCAxIDAgNjAuMzMwNjY2bC00NjkuMzMzMzM0IDQ2OS4zMzMzMzRhNDIuNjY2NjY3IDQyLjY2NjY2NyAwIDAgMS02MC4zMzA2NjYgMGwtMjEzLjMzMzMzNC0yMTMuMzMzMzM0YTQyLjY2NjY2NyA0Mi42NjY2NjcgMCAxIDEgNjAuMzMwNjY3LTYwLjMzMDY2NkwzODQgNjY1LjAwMjY2NyA4MjMuMTY4IDIyNS44MzQ2NjdhNDIuNjY2NjY3IDQyLjY2NjY2NyAwIDAgMSA2MC4zMzA2NjcgMHoiPjwvcGF0aD48L3N2Zz4=) 
 **/
export default function FoxIconCheck(_ref) {
  var size = _ref.size,
    color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    spin = _ref.spin,
    rotate = _ref.rotate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgStyle = React.useMemo(function () {
    return rotate ? {
      msTransform: "rotate(".concat(String(rotate), "deg)"),
      transform: "rotate(".concat(String(rotate), "deg)")
    } : undefined;
  }, [rotate]);
  var customStyle = React.useMemo(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color, rotate]);
  var realStyle = React.useMemo(function () {
    if (style) {
      return _objectSpread(_objectSpread({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    role: "img",
    className: classNames("appicon app_icon", className, spin ? "appicon-spin" : ""),
    style: realStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Memo, {
      style: svgStyle
    })
  }));
}